import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';

const ReportInvoicesSentToReckonData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [sentDate, setSentDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunInvoicesSentToReckonReport&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                setLoading(false);
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleSentDateChange = (e: any) => {
        let error = errors;
        delete error["sentDate"];
        setErrors(error);

        setSentDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!sentDate) {
            formIsValid = false;
            errorList["sentDate"] = "Sent Date is required";
        }

        if (!DateHelpers.isValidDate(sentDate)) {
            formIsValid = false;
            errorList["sentDate"] = "Sent Date must be < End Date";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios('api/Report/ExportInvoicesSentByDate?InvoiceSentDate=' + sentDate + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "InvoicesSentToReckon.xlsx");
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Invoices Sent to Reckon Report</h1>
            </div>
            <div className="marginTop20">
                <div>Report showing all invoices sent to Reckon on the selected date.</div>
                <span>Select a Sent Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="sentDate">
                    <span className="label">Sent Date</span>
                    <input type='date' id="sentDate" name="sentDate" className='input' value={sentDate} onChange={(e) => handleSentDateChange(e)}></input>
                </label>
                <span className={errors["sentDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["sentDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportInvoicesSentToReckonData;